import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "100%",
		display: "flex",
		color: theme.palette.colors.white,
	},
	buttonText: {
		fontFamily: "Inter-SemiBold",
		fontSize: "20px",
	},
	buttonUnit: {
		fontFamily: "Inter-Regular",
		marginLeft: "3px",
		fontSize: "14px",
	},
	buttonOldPrice: {
		fontFamily: "Inter-Regular",
		fontSize: "12px",
		marginRight: "2px",
		"&:before": {
			content: '" "',
			display: "block",
			height: "1px",
			width: "26px",
			backgroundColor: theme.palette.colors.white,
			transform: "rotate(20deg) translate(1px,4px)",
		},
	},
}));

export const TextButton = (props) => {
	const classes = useStyles();
	const { license_fee_month, displayPrice } = props;

	let isOldPrice =
		license_fee_month < displayPrice ? (
			<div className={classes.buttonOldPrice}>{displayPrice}</div>
		) : (
			""
		);

	return (
		<div className={classes.root}>
			{isOldPrice}
			<div className={classes.buttonText}>{license_fee_month}</div>
			<span className={classes.buttonUnit}>₽/мес</span>
		</div>
	);
};
